<template>
  <div>
    <homepage>
      <div class="m-block">
        <h2>{{ news.title }}</h2>
        <div class="blog-single-head-date">
          <p>
            <div href="javascript:;"><i class="fa fa-calendar"></i> Publicado em {{ formatDate(news.dateTime) }}</div>
          </p>
        </div>
        <div v-html="news.content"></div>
      </div>
      <slot></slot>
    </homepage>
  </div>
</template>
<script>
import Homepage from '@/pages/portal/Homepage'
import NewsClient from '@/services/resource_client/news'
import DateFormatter from '@/services/date_formatter'

export default {
  name: 'ReadNews',
  components: { Homepage },
  props: [ 'id' ],
  data () {
    return {
      news: {}
    }
  },
  created () {
    NewsClient.get(this.id)
    .then(r => { this.news = r.data })
  },
  methods: {
    formatDate (date) {
      return DateFormatter.formatIsoDate(date)
    }
  }
}
</script>



// WEBPACK FOOTER //
// ReadNews.vue?d388bb4c